import { List } from "antd";

import { ALERT_LABELS, PRESET_STAFF_ALERTS, describePresetAlert } from "../supportAlertConstants";
import { StepContainer } from "./styles";

// Final add-flow step: summarize the recipient and the alerts that will be created for the
// active flow. Guards against an unselected recipient before dereferencing an employee.
const ConfirmStep = ({ recipientToAdd, employees, userFlow, alertsToAdd, copyStaffId, copyableRecipients }) => {
  const isEmployee = recipientToAdd.employeeOrContact === "employee";
  const employee = isEmployee ? employees.find((e) => e.user.id === recipientToAdd.employee) : null;
  if (isEmployee && !employee) return null;
  if (!isEmployee && !recipientToAdd.newName) return null;

  const name = isEmployee ? `${employee.user.first_name} ${employee.user.last_name}` : recipientToAdd.newName;
  const email = isEmployee ? employee.user.email : recipientToAdd.newEmail;
  const phone =
    isEmployee && recipientToAdd.staffPhone
      ? recipientToAdd.staffPhone
      : !isEmployee && recipientToAdd.newPhone
      ? recipientToAdd.newPhone
      : null;
  const copySource = copyableRecipients.find((recipient) => recipient.id === copyStaffId);

  return (
    <StepContainer>
      <div className={"margin-bottom-2"}>
        <h3>Please Confirm New Alert Details</h3>
      </div>
      <h4>{name}</h4>
      {email && <h5>{email}</h5>}
      {phone && <h5>{phone}</h5>}
      <List>
        {userFlow === "customAlerts" &&
          alertsToAdd.map((alert, i) => <List.Item key={i}>{ALERT_LABELS[alert.alert_class]}</List.Item>)}
        {userFlow === "usePresetAlerts" &&
          PRESET_STAFF_ALERTS.map((alertClass) => (
            <List.Item key={alertClass}>{describePresetAlert(alertClass)}</List.Item>
          ))}
        {userFlow === "copyExistingAlerts" && (
          <List.Item>Copying alerts from {copySource?.name || "the selected recipient"}</List.Item>
        )}
      </List>
    </StepContainer>
  );
};

export default ConfirmStep;
